module.exports = __webpack_public_path__ + "assets/img/loading.708f3cb4.svg";